"use strict";

import angular from "angular";
import { AccountingPlanEntity } from "../../entity/AccountingPlanEntity";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { PlanMockNew } from "../../shared/constants/plans.constants";
import { nucontersUsers } from "../../utils/users-roles/users-roles";

angular.module("nucont.plans").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.plans", {
        url: "planos",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-plans" */ "./plans.view.component"
            ).then(() => $ocLazyLoad.inject("nucont.plans"));
        },
        views: {
            "main@": {
                component: "adminLayoutComponent"
            },
            "admin@nucont.plans": {
                component: "plansViewComponent"
            }
        },
        data: {
            rolesGuard: [...nucontersUsers],
            layoutConfig: {
                model: "LayoutConfigModel1",
                setAttrs: [
                    {
                        object: "headerConfig",
                        path: "moduleTitle.text",
                        value: "Gestão de Planos"
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.enabled",
                        value: true
                    }
                ]
            }
        },
        resolve: {
            jwtVerified: [
                "JWTService",
                (JWTService) => JWTService.verifyTokenOnce()
            ],
            validationsContract: [
                "NavigationService",
                (NavigationService) => {
                    const accountingPlanEntity = new AccountingPlanEntity(
                        PlanMockNew
                    );
                    NavigationService.setValidationsContract(
                        accountingPlanEntity
                    );
                }
            ],
            user: [
                () => {
                    let count = 0;
                    return new Promise((resolve) => {
                        const checkUser = () => {
                            if (count > 3) return resolve(true);
                            if (new UserDataAdapter().user()?.role) {
                                return resolve(true);
                            } else {
                                setTimeout(() => {
                                    count++;
                                    checkUser();
                                }, 500);
                            }
                        };
                        checkUser();
                    });
                }
            ]
        },
        bodyClass: "plans-module"
    });
}
